export enum EnumStockStatus {
  AVAILABLE = 'AVAILABLE',
  REQUEST = 'REQUEST',
  STOPSALE = 'STOPSALE'
}
